<template>
  <tr>
    <td>
      <span v-b-popover.hover.top="model.description" class="text-tooltip">
        {{ model.name }}
      </span>
      <template v-if="isAuthenticatedUserHasAccess">
        <p v-for="(pool, i) in model.pools" :key="i" class="mb-0 mt-1">
          <span class="text-black-50">&boxur;</span>
          {{ pool.pool_name }}
        </p>
      </template>
    </td>
    <td>
      <b-badge size="md" variant="light">{{ model.created_by }}</b-badge>
    </td>
    <!--<td class="small">
          {{ model.topicing_method | ucFirst }}
    </td>-->
    <td class="text-center">
      <b-progress :value="modelProcess" class="model-status" v-if="model.status.code === 2 || isCalculating">
        <b-progress-bar
          :label="modelProcess + '%'"
          :value="modelProcess"
          variant="success"
        ></b-progress-bar>
      </b-progress>

      <b-badge size="md" :variant="modelStatus" v-else>
        {{getStatus(model.status.label)}}
      </b-badge>
    </td>
    <!-- <td>
      <b-progress :value="modelProcess" class="">
        <b-progress-bar
          :label="modelProcess + '%'"
          :value="modelProcess"
          variant="success"
        ></b-progress-bar>
      </b-progress>
    </td> -->
    <td class="text-right">
      <b-btn-group>
        <b-btn
          v-if="loadFailed"
          variant="outline-secondary"
          size="sm"
          @click="loadModel"
        >
          <i class="fa fa-calculator" />
          Retry load
        </b-btn>
        <b-btn v-else-if="showSpinner" variant="outline-secondary" size="sm">
          <i class="fas fa-circle-notch fa-spin" />
        </b-btn>
        <b-btn
          v-else-if="model.status.code === 1"
          variant="outline-secondary"
          size="sm"
          @click="startComputing('preprocess_hmodel')"
        >
          <i class="fa fa-puzzle-piece" />
          Start computing
        </b-btn>
        <b-btn
          v-else-if="model.status.code === 3"
          variant="outline-secondary"
          size="sm"
          @click="startComputing('retry')"
        >
          <i class="fa fa-puzzle-piece" />
          Retry computing
        </b-btn>
        <b-btn
          v-else-if="instanceReady && isAuthenticatedUserHasAccess && model.status.code === 4"
          variant="outline-secondary"
          size="sm"
          @click="loadModel"
        >
          <i class="fa fa-eye" />
          Explore
        </b-btn>
        <b-btn
          v-else-if="instanceReady && !isAuthenticatedUserHasAccess && model.status.code === 4"
          variant="outline-secondary"
          size="sm"
          @click="loadModel"
        >
          <i class="fa fa-eye" />
          Discover
        </b-btn>
        <!--<b-btn
          v-else-if="instanceReady && isAuthenticatedUserHasAccess && model.status.code === 4"
          variant="outline-secondary"
          size="sm"
          :disabled="model.is_active"
          @click="loadModel"
        >
          <i class="fa fa-eye" />
          {{ model.is_active? 'In Use by:'+model.active_user:'Explore' }}
        </b-btn>
        <b-btn
          v-else-if="instanceReady && !isAuthenticatedUserHasAccess && model.status.code === 4"
          variant="outline-secondary"
          size="sm"
          :disabled="model.is_active"
          @click="loadModel"
        >
          <i class="fa fa-eye" />
          {{ model.is_active? 'In Use by:'+model.active_user:'Discover' }}
        </b-btn>-->
        <b-btn
          v-if="model.status.code === 3"
          variant="outline-danger"
          size="sm"
          @click="showErrormodel"
        >
          <i class="fa fa-info" />
          Error Details
        </b-btn>
        <b-dropdown
          v-if="project.user_allowed.includes('Owner')"
          variant="outline-secondary"
          toggle-class="text-decoration-none"
          right
          no-caret
        >
          <template slot="button-content"
            ><i class="fas fa-user-plus"></i></template>
          <b-dropdown-item
            v-for="u in discoverOptions"
            :key="u._id"
            @click="updateModelViewAccess(u._id, model._id)"
            >{{ u.user_name }} <i v-if="u.models.includes(model._id)" class="fa fa-check"/></b-dropdown-item
          >
        </b-dropdown>
        <b-dropdown
          v-if="project.user_allowed.includes('Owner')"
          variant="outline-secondary"
          toggle-class="text-decoration-none"
          right
          no-caret
        >
          <template slot="button-content"
            ><i class="fa fa-ellipsis-h"
          /></template>
          <b-dropdown-item @click="redirectToViewModel">
            Configure
          </b-dropdown-item>
          <b-dropdown-item @click="redirectToEditModel">
            Edit model
          </b-dropdown-item>
          <b-dropdown-item @click="confirmRemoveModel">
            Remove model
          </b-dropdown-item>
          <b-dropdown-item v-if="model.status.code === 4" @click="startComputing('preprocess_hmodel')">
            Compute again
          </b-dropdown-item>
        </b-dropdown>
      </b-btn-group>
    </td>
  </tr>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { TOGGLE_LOADING } from "@/store/mutation-types";

export default {
  name: "ProjectViewModelRow",
  props: {
    model: {
      type: Object,
      required: true,
    },
    project: {
      type: Object,
      required: true,
    },
    userOptions: {
      type: Array
    },
    discoverOptions: {
      type: Array
    }
  },
  data() {
    return {
      loadFailed: false,
      isCalculating: false,
      isExploring: false,
      batching: true
    };
  },
  computed: {
    ...mapGetters(["isAuthenticatedUserHasAccess","poolById"]),
    ...mapState({
      apiId: (state) => state.api.apiId,
      apiLoaded: (state) => state.api.apiLoaded,
      dataSettings: (state) => state.setting.dataSettings,
      instanceReady: (state) => state.api.instanceReady,
      users: (state) => state.user.users,
      importedFile: (state) => state.impexp.importedFile,
    }),
    modelProcess() {
      return this.model.status.code === 1
        ? 0
        : Math.round(this.model.status.progress * 100);
    },
    modelStatus() {
      let status = ["light", "dark", "info", "danger", "success"];
      return status[this.model.status.code];
    },
    showSpinner() {
      if (
        this.model.status.code === 2 ||
        this.isCalculating ||
        this.isExploring
      ) {
        return true;
      }

      return false;
    }
  },
  watch: {
    model(value) {
      if (value.status !== 2) {
        this.isCalculating = false;
      }
    },
  },
  mounted() {
    if (this.importedFile && !this.importedFile.status.calculate) {
      this.startComputing("preprocess_hmodel");
      let imported = this.importedFile;
      imported.status.calculate = true;
      this.saveImportFile(imported);
    }
    this.getBatchingStatus(this.model._id).then(res => {
      if(res.status === "No"){
        console.log("Batching is not enabled for this model");
        this.batching = false;
      }
    });
  },
  methods: {
    ...mapActions([
      "checkAPI",
      "loadAPI",
      "processModel",
      "retryModel",
      "removeModel",
      "resetModel",
      "saveApiId",
      "saveImportFile",
      "updateUserAccess",
      "getBatchingStatus",
      "initiateManualBatching"
    ]),
    ...mapMutations([TOGGLE_LOADING]),
    startComputing(method) {
      this.isCalculating = true;
      this.processModel({
        method: method,
        modelId: this.model._id,
      }).then(() => {
        this.$emit("resumeFetchProject");
      });
    },
    loadModel() {
      this.isExploring = true;
      this.saveApiId({
        apiId: this.model._id,
        currentProjectName: this.project.name,
        currentModelName: this.model.name,
        currentDbType: this.model.pools[0].type
      }).then(() => {
        //this.$emit("pauseFetchProject");
        this.loadAPI()
          .then(() => {
            const checkAPIInterval = () => {
              this.checkAPI().then((ready) => {
                if (ready === true) {
                  clearInterval(this.modelInterval);
                  this.$router.push({ name: "ExploreDiscover" });
                }
                if (ready === false) {
                  this.loadFailed = true;
                  this.isExploring = false;
                  clearInterval(this.modelInterval);
                  this.$toasted.show("Load failed", { type: "error" });
                }

                // if ready === null, API is still loading
              });
            };

            this.modelInterval = setInterval(checkAPIInterval, 3000);
            checkAPIInterval();
          })
          .catch((error) => {
            console.error(error);
            console.error(error.response.data);
            this.loadFailed = true;
            this.isExploring = false;
            clearInterval(this.modelInterval);
            this.$emit("resumeFetchProject");
          });
      });
    },
    confirmRemoveModel() {
      this.$bvModal
        .msgBoxConfirm(
          `Are you sure you want to remove the model “${this.model.name}”?`,
          this.$confirmOptions
        )
        .then((value) => {
          if (!value) {
            return;
          }
          this.removeModel({ id: this.model._id }).then(() => {
            this.$emit("fetchProjectModels");
            this.$toasted.show("Model removed");
          });
        });
    },
    showErrormodel() {
      const h = this.$createElement;
      // Using HTML string
      const description = h("pre", {
        class: ["modal-scrollable", "danger"],
        domProps: { innerHTML: this.model.status.text },
      });
      this.$bvModal
        .msgBoxOk([description], {
          title: "Error Details",
          size: "lg",
          buttonSize: "sm",
          okVariant: "dark",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
        })
        .then(() => {
          return;
        });
    },
    /*getPoolName(id) {
      const p = this.poolById({ id: id });
      if (!p) {
        return "?";
      }
      return p.name;
    },*/
    getUserInfo(userId) {
      const user = this.users.find((u) => u._id === userId);
      return user ? user.full_name : null;
    },
    getStatus(label) {
      if (label === "Ready") {
        return "Not Yet Calculated";
      }
      if (label === "Preprocessing") {
        return "Preprocessing";
      }
      if (label === "Busy Modeling") {
        return "Busy Modeling";
      }
      if (label === "ERROR") {
        return "Calculation Failed";
      }
      if (label === "Done") {
        return "Ready";
      }
    },
    redirectToViewModel() {
      this.$router.push({
        name: "ModelView",
        params: { modelId: this.model._id, projectId: this.project._id },
      });
    },
    redirectToEditModel() {
      this.$router.push({
        name: "ModelEdit",
        params: { modelId: this.model._id, projectId: this.project._id },
      });
    },
    updateModelViewAccess(user, resource){
      this.updateUserAccess({user: user, resource: resource}).then(res => {
        console.log(res);
        this.$emit("fetchProject");
        this.$toasted.show("Model Sharing Updated");
      })
    }
  },
};
</script>
